import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@components/atoms/button';
import { Typography } from '@components/atoms/typography';
import type { SuccessProps } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/tabs/selfie/liveness/step/success/types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useAppTheme } from '@theme';
import { getImageUrl } from '@utils/get-image-url';

export const Success = ({ onSubmit, isLoading }: SuccessProps) => {
    const { t } = useTranslation();
    const theme = useAppTheme();
    const matchesMobileSm = useMediaQuery(`(max-width:${theme.breakPoints.sm})`);

    return (
        <Stack
            sx={{
                display: 'flex',
                flex: 1,
                alignItems: 'center',
                justifyContent: 'flex-start',
                mt: 4,
            }}
        >
            <Box
                component='img'
                src={getImageUrl('/images/sdk/selfie/liveness-success.svg')}
                alt='Success icon'
            />
            <Typography tag='h2' variant='h2' sx={{ textAlign: 'center', mt: 1, mb: 3 }}>
                {t('docVerificationWidget.liveness.success.title')}
            </Typography>
            <Typography tag='p' variant='text-medium' sx={{ textAlign: 'center' }}>
                {t('docVerificationWidget.liveness.success.continue')}
            </Typography>
            <Box
                sx={{
                    mt: 'auto',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    pt: 3,
                    width: '100%',
                }}
            >
                <Button
                    variant='primary'
                    sx={{ mt: 'auto', width: matchesMobileSm ? '100%' : undefined }}
                    size='xl'
                    onClick={onSubmit}
                    loading={isLoading}
                >
                    {t('common.continue')}
                </Button>
            </Box>
        </Stack>
    );
};
